import {
	//getStepProvider,
	getStepsProviderError,
	getStepsProviderStart,
	getStepsProviderSuccess,
	setFlowStep,
	setItemFlow,
	setReasonCondition,
	clearWasReasonAdded,
	setReclamationComment,
	setReclamationImages,
	setShippingOption,
	cleanItems,
	setFAQs,
	showPartialErrorPopup,
	removeItemFlow,
} from './slices'
import Api from 'utils/api'
import {
	clearFlowOrder,
	loaderStart,
	loaderStop,
} from 'containers/Orders/slices'
import { showPopup } from '../Modal/slices'

export const getPartialSteps = (requestData) => async (dispatch) => {
	try {
		dispatch(getStepsProviderStart())
		if (requestData) {
			Api.post('/cart/partial', requestData)
				.then((res) => {
					dispatch(getStepsProviderSuccess(res))
				})
				.catch((err) => {
					dispatch(showPartialErrorPopup(err))
					dispatch(showPopup(err))
				})
		}
	} catch (error) {
		dispatch(getStepsProviderError())
	}
}
export const getFAQs = (requestData) => async (dispatch) => {
	try {
		dispatch(getStepsProviderStart())
		if (requestData) {
			Api.get(
				`/categories/${requestData.category}/faqs/${requestData.locale}?shopId=${requestData.shopId}`
			).then((res) => {
				dispatch(setFAQs(res))
			})
		}
	} catch (error) {
		dispatch(getStepsProviderError())
	}
}

export const setFlowStepperStep = (flowStepName) => async (dispatch) => {
	dispatch(setFlowStep(flowStepName))
}

export const setItemFlowReq = (item) => async (dispatch) => {
	try {
		dispatch(loaderStart())
		dispatch(setItemFlow(item))
		dispatch(loaderStop())
	} catch (error) {
		dispatch(loaderStop())
	}
}

export const addReasonCondition = (
	attrValue,
	attrType,
	itemIndex,
	orderItemId
) => async (dispatch) => {
	let reasonConditionData = { attrValue, attrType, itemIndex, orderItemId }
	dispatch(setReasonCondition(reasonConditionData))
}

export const addReclamationComment = (comment, itemIndex) => async (
	dispatch
) => {
	let commentData = { comment, itemIndex }
	dispatch(setReclamationComment(commentData))
}

export const addReclamationImages = (images, itemIndex) => async (dispatch) => {
	let imagesData = { images, itemIndex }
	dispatch(setReclamationImages(imagesData))
}

export const clearReclamationImages = (images, itemIndex) => async (
	dispatch
) => {
	let imagesData = { images, itemIndex }
	dispatch(setReclamationImages(imagesData))
}

export const skipWasReasonAdded = () => async (dispatch) => {
	dispatch(clearWasReasonAdded())
}

export const addShippingOption = (shippingOptionData) => async (dispatch) => {
	dispatch(setShippingOption(shippingOptionData))
}

export const clearHandledItems = () => async (dispatch) => {
	dispatch(cleanItems())
}
export const removeItemFlowReq = ({ flow, orderItemId, orderId }) => async (
	dispatch
) => {
	await dispatch(
		removeItemFlow({
			flow,
			orderItemId,
		})
	)
	await dispatch(clearFlowOrder(orderId))
}
